import isType from './is-type';
var isRegExp = function (str) {
  return isType(str, 'RegExp');
};
export default isRegExp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/is-reg-exp.js
// module id = 91
// module chunks = 0